import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { EMPTY_REQUEST_SERVICE_CODE_ENTITY, RequestServiceCodeEntity } from "domain/entity/RequestServiceCode/RequestServiceCodeEntity";
import { RequestServiceCodeRepository } from "domain/repository/RequestServiceCode/RequestServiceCodeRepo";
import { createRequestServiceCodeValidationSchema } from "presentation/constant/RequestServiceCode/RequestServiceCodeValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { RequestServiceCodeModel } from "presentation/model/RequestServiceCode/RequestServiceCodeModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface RequestServiceCodeVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<RequestServiceCodeModel>> | ((value: SetStateAction<RequestServiceCodeModel>) => void),
    ],
    repo: RequestServiceCodeRepository,
}

export const RequestServiceCodeVM = ({ dispatch, repo }: RequestServiceCodeVMProps) => {
    const [requestServiceCodeDispatch] = dispatch;

    const onSearch = async () => {
        requestServiceCodeDispatch(prevState => {
            return {
                ...prevState,
                requestServiceCodeList: []
            }
        });
        await repo.getEntities().then((data) => {
            requestServiceCodeDispatch(prevState => {
                return {
                    ...prevState,
                    requestServiceCodeList: data,
                    isShowEditPanel: false,
                    isAdd: false,
                    isEdit: false,
                }
            });
        });
    }

    const onCloseEidtPanel = async () => {
        requestServiceCodeDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: { ...EMPTY_REQUEST_SERVICE_CODE_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        });
    }

    const onSave = async (row: RequestServiceCodeEntity) => {
        const valResult = await Validation(createRequestServiceCodeValidationSchema).ValidateFormOnly(row);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            requestServiceCodeDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        return await repo.onSave(row);
    }

    const onFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        requestServiceCodeDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        requestServiceCodeDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }

    const onResetClick = async (isAdd: boolean) => {
        requestServiceCodeDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: isAdd ? { ...EMPTY_REQUEST_SERVICE_CODE_ENTITY } : prevState.currentRow,
            }
        })
    }

    const onEditClick = async () => {
        requestServiceCodeDispatch(prevState => {
            return {
                ...prevState,
                isEdit: true,
            }
        })
    }

    const onRowDoubleClick = async (entity: RequestServiceCodeEntity) => {
        requestServiceCodeDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: entity,
                currentRow: entity,
                isShowEditPanel: true,
            }
        })
    }

    const onAddClick = async () => {
        requestServiceCodeDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: { ...EMPTY_REQUEST_SERVICE_CODE_ENTITY },
                isAdd: true,
                isShowEditPanel: true,
            }
        })
    }

    const updateSelectedRows = async (rows: RequestServiceCodeEntity[]) => {

        requestServiceCodeDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: rows,
            }
        })
    }

    const onSaveClicked = () => {
        requestServiceCodeDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    return {
        updateSelectedRows: updateSelectedRows,
        onAddClick: onAddClick,
        onRowDoubleClick: onRowDoubleClick,
        onEditClick: onEditClick,
        onResetClick: onResetClick,
        onCheckboxChange: onCheckboxChange,
        onFieldChange: onFieldChange,
        onSave: onSave,
        onCloseEidtPanel: onCloseEidtPanel,
        onSearch: onSearch,
        onSaveClicked: onSaveClicked,
    }
}